// Consumer Dashboard page

// Default
import React, { useEffect, useMemo, useState } from "react";
import { useLocation } from "react-router-dom";

// Mui
import Drawer from "@mui/material/Drawer";
import Box from "@mui/material/Box";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import Tab from "@mui/material/Tab";
import TabContext from "@mui/lab/TabContext";
import TabList from "@mui/lab/TabList";
import TabPanel from "@mui/lab/TabPanel";
import TableCell from "@mui/material/TableCell";
import TableRow from "@mui/material/TableRow";
import { findValue, transformV2Record } from "../../utils/meterDataMapper";
import {
  CardContent,
  CardHeader,
  Divider,
  Grid2,
  IconButton,
  Popover,
} from "@mui/material";
// Mui
import Card from "@mui/material/Card";

// Custom
import Layout from "../../layout";
import Spinner from "../../components/spinner/Spinner";
import ConsumerDrawerContent from "../../components/consumerCardsMoc/ConsumerMeterDrawerContent";
import MeterEvents from "../../components/consumerCardsMoc/MeterEvents";
import MockMeterEvents from "../../components/consumerCardsMoc/MockMeterEvents";
import HeaderAssociatedMeterLogs from "../../components/meterCardMock/HeaderAssociatedMeterLogs";
import CustomToast from "../../components/toast/CustomToast";
import ConfirmationModal from "../../components/modals/ConfirmationModal";

// SVG
import Download from "../../assets/svg/download";

// Theme

// Redux
import { useAppDispatch, useAppSelector } from "../../redux/hooks";
import { setAllMeters, setTotalMeters } from "../../redux/features/MeterSlice";
import {
  setCustomerDetails,
  setHasSearched,
  setIsCustomerLoading,
} from "../../redux/features/CustomerSlice";

// Utils
import { fetchGETRequest, fetchPUTRequest } from "../../utils/services";
import {
  formatDate,
  formatMeterSerialNumber,
  formatTime,
} from "../../utils/helper";
import { LiveDataRecord, ToastState } from "../../types";
import MeterMock from "../../components/meterCardMock/meter";
import MeterHeader from "../../components/meterCardMock/MeterHeader";
import DateAndTimePopover from "../../components/popovers/DateAndTimePopover";
import CreateReadValueModel from "../../components/modals/CreateReadValue";
import UpdateReadValueModel from "../../components/modals/UpdateReadValue";
import moment from "moment";
import useReadCluster from "../../hooks/useReadCluster";
import useMeterDeviceEvents from "../../hooks/useMeterDeviceEvents";
import CustomInputLabelSelect from "../../forms/select/InputLabelCustomSelect";
import DownArrow from "../../assets/svg/downArrow";
import Calendar2 from "../../assets/svg/calendar2";
import ContainedButton from "../../forms/button/ContainedButton";
import LottieLoader from "../../components/animatedLoader/LottieLoader";
import ReadClusterLineChart from "../../components/charts/ReadClusterLineChart";
import CustomDataTable from "../../components/table/CustomTable";
import { Edit2 } from "lucide-react";
import CustomOutlinedSelect from "../../forms/select/OutlinedCustomSelect";

interface MeterData {
  meterId: string;
  serialNumber: string;
  meterType: string;
  meterNumber: string;
  meterStatus: string;
  id: string;
  status: null;
  timeseries: {
    date: string;
    value: string;
  };
}

interface ConfirmModalState {
  open: boolean;
  data: any;
  type: string;
}

interface TimeStampState {
  start: number;
  end: number;
}

// const DummyData = [
//   {
//     id: {
//       entityType: "DEVICE",
//       id: "53d72190-19b8-11f0-973b-51a0d84831aa",
//     },
//     createdTime: 1744693991977,
//     tenantId: {
//       entityType: "TENANT",
//       id: "bfdc8410-e773-11ef-a6a1-c5603cdacbcd",
//     },
//     customerId: {
//       entityType: "CUSTOMER",
//       id: "432c77f0-19b8-11f0-973b-51a0d84831aa",
//     },
//     name: "PC-24080009",
//     type: "default",
//     label: "",
//     deviceProfileId: {
//       entityType: "DEVICE_PROFILE",
//       id: "bff51520-e773-11ef-a6a1-c5603cdacbcd",
//     },
//     firmwareId: null,
//     softwareId: null,
//     externalId: null,
//     version: 1,
//     deviceData: {
//       configuration: {
//         type: "DEFAULT",
//       },
//       transportConfiguration: {
//         type: "DEFAULT",
//       },
//     },
//     additionalInfo: {
//       gateway: false,
//       overwriteActivityTime: false,
//       description: "",
//     },
//     value: 0,
//     status: "Connect",
//   },
//   {
//     id: {
//       entityType: "DEVICE",
//       id: "624d5f00-19b8-11f0-973b-51a0d84831aa",
//     },
//     createdTime: 1744694016240,
//     tenantId: {
//       entityType: "TENANT",
//       id: "bfdc8410-e773-11ef-a6a1-c5603cdacbcd",
//     },
//     customerId: {
//       entityType: "CUSTOMER",
//       id: "432c77f0-19b8-11f0-973b-51a0d84831aa",
//     },
//     name: "PC-24080011",
//     type: "default",
//     label: "",
//     deviceProfileId: {
//       entityType: "DEVICE_PROFILE",
//       id: "bff51520-e773-11ef-a6a1-c5603cdacbcd",
//     },
//     firmwareId: null,
//     softwareId: null,
//     externalId: null,
//     version: 2,
//     deviceData: {
//       configuration: {
//         type: "DEFAULT",
//       },
//       transportConfiguration: {
//         type: "DEFAULT",
//       },
//     },
//     additionalInfo: {
//       gateway: false,
//       overwriteActivityTime: false,
//       description: "",
//     },
//     value: 0,
//     status: "Disconnect",
//   },
//   {
//     id: {
//       entityType: "DEVICE",
//       id: "53d72190-19b8-11f0-973b-51a0d84831aa",
//     },
//     createdTime: 1744693991977,
//     tenantId: {
//       entityType: "TENANT",
//       id: "bfdc8410-e773-11ef-a6a1-c5603cdacbcd",
//     },
//     customerId: {
//       entityType: "CUSTOMER",
//       id: "432c77f0-19b8-11f0-973b-51a0d84831aa",
//     },
//     name: "PC-24080009",
//     type: "default",
//     label: "",
//     deviceProfileId: {
//       entityType: "DEVICE_PROFILE",
//       id: "bff51520-e773-11ef-a6a1-c5603cdacbcd",
//     },
//     firmwareId: null,
//     softwareId: null,
//     externalId: null,
//     version: 1,
//     deviceData: {
//       configuration: {
//         type: "DEFAULT",
//       },
//       transportConfiguration: {
//         type: "DEFAULT",
//       },
//     },
//     additionalInfo: {
//       gateway: false,
//       overwriteActivityTime: false,
//       description: "",
//     },
//     value: 0,
//     status: "Connect",
//   },
//   {
//     id: {
//       entityType: "DEVICE",
//       id: "624d5f00-19b8-11f0-973b-51a0d84831aa",
//     },
//     createdTime: 1744694016240,
//     tenantId: {
//       entityType: "TENANT",
//       id: "bfdc8410-e773-11ef-a6a1-c5603cdacbcd",
//     },
//     customerId: {
//       entityType: "CUSTOMER",
//       id: "432c77f0-19b8-11f0-973b-51a0d84831aa",
//     },
//     name: "PC-24080011",
//     type: "default",
//     label: "",
//     deviceProfileId: {
//       entityType: "DEVICE_PROFILE",
//       id: "bff51520-e773-11ef-a6a1-c5603cdacbcd",
//     },
//     firmwareId: null,
//     softwareId: null,
//     externalId: null,
//     version: 2,
//     deviceData: {
//       configuration: {
//         type: "DEFAULT",
//       },
//       transportConfiguration: {
//         type: "DEFAULT",
//       },
//     },
//     additionalInfo: {
//       gateway: false,
//       overwriteActivityTime: false,
//       description: "",
//     },
//     value: 0,
//     status: "Disconnect",
//   },
// ];

const MeterDashboardMock: React.FC = () => {
  const currentTimestamp = Date.now();
  const location = useLocation();
  const [disputesOpen, setDisputesOpen] = useState<MeterData | null>(null);
  const { hasMeterSearched, isMeterLoading, meterId, meterV2Details } =
    useAppSelector((state) => state.meter);
  const { environment } = useAppSelector((state) => state.auth);
  const [isLoading, setIsLoading] = useState(false);
  const [toast, setToast] = useState<ToastState>({
    message: "",
    severity: "",
  });
  const [timeStamp, setTimeStamp] = useState<TimeStampState>({
    start: currentTimestamp - 24 * 60 * 60 * 1000,
    end: currentTimestamp,
  });
  const [confirmModal, setConfirmModal] = useState<ConfirmModalState>({
    open: false,
    data: null,
    type: "",
  });
  const [statusLoader, setStatusLoader] = useState(false);

  const dispatch = useAppDispatch();

  const [value, setValue] = useState("TLR");

  const handleChange = (event: React.SyntheticEvent, newValue: string) => {
    setValue(newValue);
  };

  const getTimeSeriesOfMeter = async (deviceID: string) => {
    try {
      const response = await fetchGETRequest(
        `plugins/telemetry/DEVICE/${deviceID}/values/timeseries?keys=IP_KWH&startTs=${
          timeStamp?.start
        }&endTs=${timeStamp?.end}&limit=${10}`,
      );

      if (response) {
        return {
          date:
            (response?.["IP_KWH"]?.[0]?.ts &&
              formatDate(
                new Date(response?.["IP_KWH"]?.[0]?.ts),
                "DD MMM. 'YY",
              )) ||
            "-",
          value: response?.["IP_KWH"]?.[0]?.value || "-",
        };
      } else {
        return {
          date: "-",
          value: "-",
        };
      }
    } catch (error: any) {
      console.log(error, "---getTimeSeriesOfMeter error---");
    }
  };

  const getMeterConnectionStatus = async (deviceID: string) => {
    try {
      const response = await fetchGETRequest(
        `devices/${deviceID}/connectionstatus`,
        {},
        true,
      );

      if (response?.data?.Status) {
        switch (response?.data?.Status?.trim().toUpperCase()) {
          case "DISCONNECT SUCCESS":
            return "Disconnect";
          case "CONNECT SUCCESS":
            return "Connect";
          case "DISCONNECT IN PROGRESS":
            return "Disconnect In Progress";
          case "CONNECT IN PROGRESS":
            return "Connect In Progress";
          default:
            return null;
        }
      } else {
        return null;
      }
    } catch (error: any) {
      console.log(error, "---getMeterConnectionStatus error---");
      return null;
    }
  };

  const downloadCSV = (data: any[], meter: string) => {
    const headers = Object.keys(data[0]).join(",");
    const rows = data.map((row) => Object.values(row).join(",")).join("\n");
    const csvContent = `${headers}\n${rows}`;

    const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });

    const link = document.createElement("a");
    link.href = URL.createObjectURL(blob);
    link.download = `${window.location.pathname.slice(1)}-${meter}.csv`;
    link.click();

    URL.revokeObjectURL(link.href);
  };

  const bulkDownload = async () => {
    setIsLoading(true);

    const metersResponse = await fetchGETRequest(
      `v2/Meters/by-customer/${meterId}?pageSize=20&page=0`,
      {},
      true,
    );

    if (metersResponse?.data?.data?.length > 0) {
      const allMeters = metersResponse?.data?.data?.map((item: any) => {
        return { id: item?.id?.id, name: item?.name };
      });

      for (let i = 0; i < allMeters.length; i++) {
        const meter = allMeters[i]["id"];
        const response = await fetchGETRequest(
          `plugins/telemetry/DEVICE/${meter}/values/timeseries?keys=IP_KWH,IP_MeterTime,IP_Current,IP_Voltage,IP_Frequency,IP_NeutralCurrent,IP_PowerFactor,IP_KW,IP_KVA,IP_KWHEXP,IP_KVAH,IP_KVAHEXP,IP_MDKW,IP_MDKVA,IP_MDResetCount,IP_ProgramCount,IP_TamperCount,IP_TotalPowerOnDuration,IP_RelayStatus,IP_LoadLimitValue,EventCode,EventDescription&startTs=${timeStamp?.start}&endTs=${timeStamp?.end}&intervalType=WEEK`,
          {},
          true,
        );

        if (response?.data && Object.keys(response?.data).length !== 0) {
          const keys = Object.keys(response?.data);
          const maxRows = Math.max(
            ...Object.values(response?.data).map((arr: any) => arr.length),
          );

          const tableData = Array.from({ length: maxRows }).map(
            (_, rowIndex) => {
              let rowObject: any = {
                meter: formatMeterSerialNumber(allMeters[i]["name"]),
                timestamp:
                  formatDate(
                    new Date(response?.data[keys[0]][rowIndex]?.ts),
                    "DD/MM/YYYY HH:mm:ss",
                  ) || "N/A",
              };
              keys.forEach((key: string) => {
                rowObject[key.replace("IP_", "")] =
                  response?.data[key][rowIndex]?.value || "N/A";
              });
              return rowObject;
            },
          );
          downloadCSV(tableData, meter);
        } else {
          setToast({
            message: `No data found for meter: ${meter}`,
            severity: "error",
          });
        }
      }
    } else {
      setToast({
        message: `No meters found.`,
        severity: "error",
      });
    }

    setIsLoading(false);
  };

  const toggleStatusChange = async () => {
    try {
      setStatusLoader(true);
      let body = {
        deviceIds: [confirmModal?.data?.id],
        command: "",
        projectName: "",
      };
      if (confirmModal?.type === "connect") {
        body.command = "ExecuteConnect";
      } else {
        body.command = "ExecuteDisconnect";
      }

      const response = await fetchPUTRequest(`devices/command`, body);
      getMeterConnectionStatus(confirmModal?.data?.id);

      handleSearch();
    } catch (error: any) {
      setToast({
        message: error.message,
        severity: "error",
      });
    } finally {
      setStatusLoader(false);
      setConfirmModal({
        open: false,
        data: null,
        type: "",
      });
    }
  };

  const handleSearch = async () => {
    try {
      dispatch(setIsCustomerLoading(true));

      const [responseLeft, responseRight] = await Promise.all([
        fetchGETRequest(`v2/Customers/${meterId || location?.state}`),
        fetchGETRequest(
          `v2/Meters/by-customer/${meterId || location?.state}?pageSize=20&page=0`,
        ),
      ]);

      if (responseLeft?.status === 400 || responseLeft?.status === 404) {
        setTimeout(() => {
          dispatch(setIsCustomerLoading(false));
          setToast({ message: "Consumer not found", severity: "error" });
        }, 3000);
        return;
      }

      if (responseLeft?.data) {
        dispatch(setCustomerDetails(responseLeft.data));
      }

      if (responseRight?.data?.length > 0) {
        dispatch(setTotalMeters(responseRight.data?.length));

        const sortedData = responseRight.data.slice().reverse();

        dispatch(setAllMeters(sortedData));

        await getMeterConnectionStatus(sortedData?.[0]?.id?.id);
        await getTimeSeriesOfMeter(sortedData?.[0]?.id?.id);
      }

      // setTimeout(() => {
      dispatch(setHasSearched(true));
      dispatch(setIsCustomerLoading(false));
      // }, 3000);
    } catch (error: any) {
      dispatch(setIsCustomerLoading(false));
      setToast({ message: error.message, severity: "error" });
    }
  };

  return (
    <Layout>
      <MeterHeader />
      <CustomToast
        open={toast?.message}
        severity={toast?.severity}
        setToast={setToast}
      />
      {isMeterLoading && (
        <Box mt={"20px"}>
          <Spinner />
        </Box>
      )}

      {!hasMeterSearched && !isMeterLoading && (
        <Box display={"flex"} flexDirection={"column"} gap={"20px"}>
          <HeaderAssociatedMeterLogs />
          <MeterMock />
          {/* <Typography
            variant="h6"
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >

          </Typography> */}
        </Box>
      )}

      {hasMeterSearched && !isMeterLoading && (
        <Box
          sx={{
            width: "100%",
            typography: "body1",
            backgroundColor: "white",
            p: "12px 0px 0px 0px",
            borderRadius: 3,
            mt: 2,
          }}
        >
          <TabContext value={value}>
            <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
              <TabList
                onChange={handleChange}
                aria-label="lab API tabs example"
                sx={{ height: 30, minHeight: 30 }}
              >
                <Tab
                  label="Telemetry Readings"
                  value="TLR"
                  sx={{ textTransform: "none", minHeight: 28, height: 28 }}
                />
                <Tab
                  label="Meter Events"
                  value="ME"
                  sx={{ textTransform: "none", minHeight: 28, height: 28 }}
                />
                {/* <Tab
                  label="Item Two"
                  value="2"
                  sx={{ textTransform: "none", minHeight: 28, height: 28 }}
                />
                <Tab
                  label="Item Three"
                  value="3"
                  sx={{ textTransform: "none", minHeight: 28, height: 28 }}
                /> */}
              </TabList>
            </Box>
            <TabPanel value="TLR" sx={{ p: 0 }}>
              <RenderTlr id={meterId} />
            </TabPanel>
            <TabPanel value="ME" sx={{ p: 0 }}>
              {environment === "Test" ? (
                <MeterEvents
                  meterSerialNumber={meterV2Details?.meterNumber || ""}
                />
              ) : (
                <MockMeterEvents />
              )}
            </TabPanel>
          </TabContext>
        </Box>
      )}

      {disputesOpen && (
        <Drawer
          anchor={"right"}
          open={true}
          onClose={() => setDisputesOpen(null)}
          PaperProps={{
            sx: {
              backgroundColor: "#ffffff",
              boxShadow: "none",
              width: "60%",
              padding: "0px",
              borderTopLeftRadius: 16,
              borderBottomLeftRadius: 16,
              opacity: 1,
            },
          }}
        >
          <Box>
            <ConsumerDrawerContent
              data={disputesOpen}
              onClose={() => {
                setDisputesOpen(null);
              }}
            />
          </Box>
        </Drawer>
      )}
      <ConfirmationModal
        confirmModal={confirmModal?.open}
        onClose={() =>
          setConfirmModal({
            open: false,
            data: null,
            type: "",
          })
        }
        onClick={toggleStatusChange}
        body={"Are you sure want to change meter status."}
        isLoading={statusLoader}
      />
    </Layout>
  );
};

export default MeterDashboardMock;

const getTimeStamp = (newTime: string, newDate: Date): number => {
  const [hours, minutes] = newTime.split(":").map(Number);

  // Create a moment object in local timezone using newDate
  const localMoment = moment(newDate).set({
    hour: hours,
    minute: minutes,
    second: 0,
    millisecond: 0,
  });

  return localMoment.valueOf(); // Local timestamp in milliseconds
};

interface RegisterType {
  type: string;
  value: string;
}

const PROFILE_TYPES = [
  { type: "Instant read", value: "Instant" },
  { type: "Block Read", value: "Load Profile" },
  { type: "Daily read", value: "Daily" },
  { type: "Billing read", value: "Billing" },
];

const PROFILE_OPTIONS: Record<string, RegisterType[]> = {
  Instant: [
    { type: "Voltage", value: "voltage" },
    // { type: "Voltage L1", value: "voltageL1" },
    // { type: "Voltage L2", value: "voltageL2" },
    // { type: "Voltage L3", value: "voltageL3" },
    { type: "Current", value: "phaseCurrent" },
    // { type: "Current L1", value: "currentL1" },
    // { type: "Current L2", value: "currentL2" },
    // { type: "Current L3", value: "currentL3" },
    { type: "Neutral Current", value: "neutralCurrent" },
    { type: "Power Factor", value: "powerFactor" },
    { type: "Frequency", value: "frequency" },
    { type: "Apparent Power (VA)", value: "apparentPowerVa" },
    { type: "Active Power (W)", value: "activePowerW" },
    { type: "Reactive Power (VAR)", value: "reactivePowerVar" },
    { type: "kWh Import", value: "cumulativeEnergyKwhImport" },
    { type: "kVah Import", value: "cumulativeEnergyKvahImport" },
    { type: "kWh Export", value: "cumulativeEnergyKwhExport" },
    { type: "kVah Export", value: "cumulativeEnergyKvahExport" },
    { type: "MD (kW)", value: "maxDemandKw" },
    { type: "MD (kVA)", value: "maxDemandKva" },
    { type: "Tamper Count", value: "tamperCount" },
    { type: "Billing Count", value: "billingCount" },
    { type: "Programming Count", value: "programmingCount" },
    { type: "Relay Status", value: "relayStatus" },
  ],
  Daily: [
    { type: "kWh Import", value: "cumulativeEnergyKwhImport" },
    { type: "kVah Import", value: "cumulativeEnergyKvahImport" },
    { type: "kWh Export", value: "cumulativeEnergyKwhExport" },
    { type: "kVah Export", value: "cumulativeEnergyKvahExport" },
    { type: "Voltage", value: "voltage" },
    { type: "Phase Current", value: "phaseCurrent" },
    { type: "Neutral Current", value: "neutralCurrent" },
    { type: "Power Factor", value: "powerFactor" },
    { type: "Frequency", value: "frequency" },
    { type: "Apparent Power (VA)", value: "apparentPowerVa" },
    { type: "Active Power (W)", value: "activePowerW" },
    { type: "Max Demand (kW)", value: "maxDemandKw" },
    { type: "Max Demand (kVA)", value: "maxDemandKva" },
    { type: "Max Demand kW Time", value: "maxDemandKwDatetime" },
    { type: "Max Demand kVA Time", value: "maxDemandKvaDatetime" },
  ],
  "Load Profile": [
    { type: "Avg Voltage", value: "avgVoltage" },
    { type: "Avg Current", value: "avgCurrent" },
    { type: "kWh Import", value: "blockEnergyKwhImport" },
    { type: "kVah Import", value: "blockEnergyKvahImport" },
    { type: "kWh Export", value: "blockEnergyKwhExport" },
    { type: "kVah Export", value: "blockEnergyKvahExport" },
  ],
  Billing: [
    { type: "Avg Power Factor", value: "avgPowerFactor" },
    { type: "Cumulative Energy (kWh)", value: "cumEnergyKwh" },
    { type: "Cumulative Energy (kVah)", value: "cumEnergyKvah" },
    { type: "Max Demand (kW)", value: "maxDemandKw" },
    { type: "Max Demand (kVA)", value: "maxDemandKva" },
    { type: "Max Demand kW Time", value: "maxDemandKwDatetime" },
    { type: "Max Demand kVA Time", value: "maxDemandKvaDatetime" },
    // { type: "Energy kWh Tz1", value: "cumEnergyKwhTz1" },
    // { type: "Energy kWh Tz2", value: "cumEnergyKwhTz2" },
    // { type: "Energy kWh Tz3", value: "cumEnergyKwhTz3" },
    // { type: "Energy kWh Tz4", value: "cumEnergyKwhTz4" },
    // { type: "Energy kWh Tz5", value: "cumEnergyKwhTz5" },
    // { type: "Energy kWh Tz6", value: "cumEnergyKwhTz6" },
    // { type: "Energy kWh Tz7", value: "cumEnergyKwhTz7" },
    // { type: "Energy kWh Tz8", value: "cumEnergyKwhTz8" },
    // { type: "Energy kVAh Tz1", value: "cumEnergyKvahTz1" },
    // { type: "Energy kVAh Tz2", value: "cumEnergyKvahTz2" },
    // { type: "Energy kVAh Tz3", value: "cumEnergyKvahTz3" },
    // { type: "Energy kVAh Tz4", value: "cumEnergyKvahTz4" },
    // { type: "Energy kVAh Tz5", value: "cumEnergyKvahTz5" },
    // { type: "Energy kVAh Tz6", value: "cumEnergyKvahTz6" },
    // { type: "Energy kVAh Tz7", value: "cumEnergyKvahTz7" },
    // { type: "Energy kVAh Tz8", value: "cumEnergyKvahTz8" },
  ],
};

const CHIP_COLORS = {
  good: "#34C759",
  pending: "#FF9500",
  failed: "#F65B5B",
  high: "#F65B5B",
  medium: "#FF9500",
  low: "#34C759",
  info: "#007AFF",
  closed: "#34C759",
  open: "#F65B5B",
  investigation: "#FF9500",
};

const startOfDayLocal = moment().startOf("day").valueOf(); // 00:00:00.000 Local
const endOfDayLocal = moment().endOf("day").valueOf(); // 23:59:59.999 Local

interface RenderTlrProps {
  id?: string;
}

const RenderTlr: React.FC<RenderTlrProps> = ({ id }) => {
  const { meterV2Details } = useAppSelector((state) => state.meter);
  const meterId = meterV2Details?.meterNumber || id;

  const [profileType, setProfileType] = useState<string>("Instant");
  const [registerType, setRegisterType] = useState<RegisterType>(
    PROFILE_OPTIONS["Instant"][0],
  );

  const COLUMNS = ["Read Date/Time", registerType.type, "VEE Status", "Action"];
  const [startDate, setStartDate] = useState<Date>(new Date());
  const [endDate, setEndDate] = useState<Date>(new Date());
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);
  const [toast, setToast] = useState<ToastState>({ message: "", severity: "" });
  const [timeRange, setTimeRange] = useState<number[]>([0, 1439]);
  const [timeStamp, setTimeStamp] = useState({
    start: startOfDayLocal,
    end: endOfDayLocal,
  });
  const [data, setData] = useState<LiveDataRecord[]>([]);
  const [chartData, setChartData] = useState<{
    xAxis: string[];
    yAxis: (string | number)[];
    legend: string;
  }>({
    xAxis: [],
    yAxis: [],
    legend: "",
  });

  const [rowsPerPage, setRowsPerPage] = useState<number>(500);
  const [page, setPage] = useState<number>(0);

  const [downloadEl, setDownloadEl] = useState<HTMLElement | null>(null);
  const [csvLoader, setCsvLoader] = useState<boolean>(false);
  const [excelLoader, setExcelLoader] = useState<boolean>(false);

  const [updateReadValueModal, setUpdateReadValueModal] =
    useState<LiveDataRecord | null>(null);

  const [createReadValueModal, setCreateReadValueModal] =
    useState<boolean>(false);

  // const { chartData, transformedLiveData: data } = convertToTlrData(
  //   DummyReadClusterData,
  //   registerType
  // );

  // Fetch a large amount of data from API, paginate client-side
  const API_FETCH_LIMIT = 10000;

  const {
    data: apiData,
    refetch,
    isLoading,
    error,
  } = useReadCluster({
    meterId: meterId || "",
    registerType,
    timeStamp,
    rowsPerPage: API_FETCH_LIMIT,
    profileType,
  });

  useEffect(() => {
    if (id) {
      refetch();
    }
  }, [id, registerType]);

  useEffect(() => {
    if (error) {
      setToast({
        message: error?.message,
        severity: "error",
      });

      setData([]);
      setChartData({ xAxis: [], yAxis: [], legend: "" });
    }
  }, [error]);

  useEffect(() => {
    if (apiData && apiData?.chartData) {
      setData(apiData?.transformedLiveData || []);
      setChartData(apiData?.chartData || { xAxis: [], yAxis: [], legend: "" });
    } else {
      setData([]);
      setChartData({ xAxis: [], yAxis: [], legend: "" });
    }
  }, [apiData]);

  const handleDateSubmit = () => {
    const startTs = getTimeStamp(formatTime(timeRange[0]), new Date(startDate));
    const endTs = getTimeStamp(formatTime(timeRange[1]), new Date(endDate));

    setTimeStamp({
      start: startTs,
      end: endTs,
    });

    setAnchorEl(null);

    setTimeout(() => {
      refetch();
    }, 500);
  };

  const downloadCSV = async () => {
    if (meterId) {
      try {
        setCsvLoader(true);
        const fromDate = moment(timeStamp.start).format("YYYY-MM-DDTHH:mm");
        const toDate = moment(timeStamp.end).format("YYYY-MM-DDTHH:mm");

        let v2Type = "instant";
        if (profileType === "Load Profile") v2Type = "load";
        else if (profileType === "Daily") v2Type = "daily";
        else if (profileType === "Billing") v2Type = "billing";

        const response = await fetchGETRequest<any>(
          `v2/meter-reads/browse?type=${v2Type}&skip=0&take=10000&search=${meterId}&from=${fromDate}&to=${toDate}`,
        );

        const records =
          response?.data?.records ||
          (Array.isArray(response?.data) ? response?.data : []);
        // const meterData = await fetchGETRequest<any>(`v2/Meters/${meterId}`);

        if (records.length > 0) {
          const currentOptions = PROFILE_OPTIONS[profileType] || [];
          const tableData = records.map((record: any) => {
            const rowData: any = {
              meter: meterId,
              receivedDate: formatDate(
                findValue(record, "receivedDate"),
                "DD/MM/YYYY HH:mm:ss",
              ),
              timestamp: "",
            };

            currentOptions.forEach((option) => {
              const { val, readingTime } = transformV2Record(
                record,
                option.value,
              );
              if (!rowData.timestamp) {
                rowData.timestamp = formatDate(
                  readingTime,
                  "DD/MM/YYYY HH:mm:ss",
                );
              }
              rowData[option.type] = val ?? "-";
            });

            rowData.currentReadQuality = "Good";
            return rowData;
          });

          const headers = Object.keys(tableData[0]).join(",");
          const rows = tableData
            .map((row: any) => Object.values(row).join(","))
            .join("\n");

          const csvContent = `${headers}\n${rows}`;
          const blob = new Blob([csvContent], {
            type: "text/csv;charset=utf-8;",
          });

          const link = document.createElement("a");
          link.href = URL.createObjectURL(blob);
          link.download = `${v2Type}-${meterId}.csv`;
          link.click();
          URL.revokeObjectURL(link.href);
        } else {
          setToast({
            message: `No data found for meter: ${meterId}`,
            severity: "error",
          });
        }
      } catch (error) {
        return error;
      } finally {
        setCsvLoader(false);
        setDownloadEl(null);
      }
    } else {
      setToast({
        message: "Please enter meter Id",
        severity: "error",
      });
    }
  };

  const downloadExcel = async () => {
    try {
      if (meterId) {
        setExcelLoader(true);
        const fromDate = moment(timeStamp.start).format("YYYY-MM-DDTHH:mm");
        const toDate = moment(timeStamp.end).format("YYYY-MM-DDTHH:mm");

        let v2Type = "instant";
        if (profileType === "Load Profile") v2Type = "load";
        else if (profileType === "Daily") v2Type = "daily";
        else if (profileType === "Billing") v2Type = "billing";

        const response = await fetchGETRequest<any>(
          `v2/meter-reads/browse?type=${v2Type}&skip=0&take=10000&search=${meterId}&from=${fromDate}&to=${toDate}`,
        );

        const records =
          response?.data?.records ||
          (Array.isArray(response?.data) ? response?.data : []);

        if (records.length === 0) {
          setToast({
            message: `No data found.`,
            severity: "error",
          });
          return;
        }

        const currentOptions = PROFILE_OPTIONS[profileType] || [];
        const transformedLiveData = records.map((record: any) => {
          const rowData: any = {
            receivedDate: formatDate(
              findValue(record, "receivedDate"),
              "DD/MM/YYYY HH:mm:ss",
            ),
            currentDateTime: "",
          };

          currentOptions.forEach((option) => {
            const { val, readingTime } = transformV2Record(
              record,
              option.value,
            );
            if (!rowData.currentDateTime) {
              rowData.currentDateTime = formatDate(
                readingTime,
                "DD/MM/YYYY HH:mm:ss",
              );
            }
            rowData[option.type] = val ?? "-";
          });

          rowData.currentReadQuality = "Good";
          return rowData;
        });

        const headers = Object.keys(transformedLiveData[0]).join("\t");
        const rows = transformedLiveData
          .map((row: any) => Object.values(row).join("\t"))
          .join("\n");
        const excelContent = `${headers}\n${rows}`;

        const blob = new Blob([excelContent], {
          type: "application/vnd.ms-excel;charset=utf-8;",
        });

        const link = document.createElement("a");
        link.href = URL.createObjectURL(blob);
        link.download = `${v2Type}-${meterId}.xls`;
        link.click();

        URL.revokeObjectURL(link.href);
      } else {
        setToast({
          message: "Please enter meter Id",
          severity: "error",
        });
      }
    } catch (error) {
      return error;
    } finally {
      setExcelLoader(false);
      setDownloadEl(null);
    }
  };

  const getStatusChip = (type: string) => {
    return (
      <Box
        sx={{
          fontSize: "10px",
          fontWeight: 600,
          lineHeight: "17px",
          letterSpacing: "0.32px",
          padding: "1px 8px",
          color: "#ffffff",
          borderRadius: "3px",
          width: "fit-content",
          background:
            type === "Failed kWh threshold validation"
              ? "#F65B5B"
              : CHIP_COLORS[type.toLowerCase() as keyof typeof CHIP_COLORS],
        }}
      >
        {type}
      </Box>
    );
  };

  // Client-side pagination: slice data based on current page
  const paginatedData = useMemo(() => {
    const startIndex = page * rowsPerPage;
    const endIndex = startIndex + rowsPerPage;
    return data.slice(startIndex, endIndex);
  }, [data, page, rowsPerPage]);

  const rowsContent = paginatedData?.map((item, index: number) => (
    <TableRow
      key={index}
      sx={{
        height: "50px",
        background: (index + 1) % 2 ? "#F9FCFE" : "transparent",
      }}
      className="custom_table_tbody"
    >
      <TableCell>
        <Typography className="custom_table_tbody_cell">
          {formatDate(
            item.readingTime || item.ts || item.currentDateTime,
            "DD/MM/YYYY HH:mm:ss",
          ) || item.currentDateTime}
        </Typography>
      </TableCell>
      <TableCell>
        <Typography className="custom_table_tbody_cell">
          {typeof item.currentRead === "boolean"
            ? item.currentRead
              ? "Open"
              : "Close"
            : item.currentRead === "true"
              ? "Open"
              : item.currentRead === "false"
                ? "Close"
                : isNaN(Number(item.currentRead))
                  ? item.currentRead
                  : Number(item.currentRead).toFixed(4)}
        </Typography>
      </TableCell>
      <TableCell>
        <Typography className="custom_table_tbody_cell">
          {getStatusChip(item.currentReadQuality)}
        </Typography>
      </TableCell>
      <TableCell>
        <IconButton onClick={() => setUpdateReadValueModal(item)}>
          {/* <UnifedIcon
            icon={Edit2}
            fontSize={8}
            style={{ color: "#000000", fontSize: "12px" }}
          /> */}
          <Edit2 color="#000000" className="!size-4" />
        </IconButton>
      </TableCell>
    </TableRow>
  ));

  const handleDateChange = (dates: [Date, Date]) => {
    const [start, end] = dates;
    setStartDate(start);
    setEndDate(end);
  };

  return (
    <Box>
      <CustomToast
        open={toast?.message}
        severity={toast?.severity}
        setToast={setToast}
      />
      <Stack>
        <Grid2 container spacing={2}>
          <Grid2 size={{ xs: 12, md: 12, lg: 7 }}>
            <Stack
              direction={"row"}
              gap={2}
              marginTop={3}
              alignItems={"center"}
              justifyContent={"space-between"}
              px={"20px"}
            >
              <Stack direction={"row"} gap={2} alignItems={"center"}>
                <CustomInputLabelSelect
                  value={
                    PROFILE_TYPES.find((p) => p.value === profileType) ||
                    PROFILE_TYPES[0]
                  }
                  onChange={(e) => {
                    const newProfile = String(e.value);
                    setProfileType(newProfile);
                    const newOptions = PROFILE_OPTIONS[newProfile] || [];
                    if (newOptions.length > 0) {
                      setRegisterType(newOptions[0]);
                    }
                  }}
                  icon={DownArrow}
                  title={"Read Type"}
                  options={PROFILE_TYPES}
                  titleSx={{
                    fontSize: "14px",
                    lineHeight: "20px",
                    whiteSpace: "nowrap",
                  }}
                  iconSx={{
                    marginRight: "5px",
                    marginTop: "5px",
                  }}
                />
                <CustomInputLabelSelect
                  value={registerType}
                  onChange={(e) =>
                    setRegisterType({
                      type: e.type,
                      value: String(e.value),
                    })
                  }
                  icon={DownArrow}
                  title={"Register Type"}
                  options={PROFILE_OPTIONS[profileType] || []}
                  titleSx={{
                    fontSize: "14px",
                    lineHeight: "20px",
                    whiteSpace: "nowrap",
                  }}
                  iconSx={{
                    marginRight: "5px",
                    marginTop: "5px",
                  }}
                />
              </Stack>
              <Stack flexDirection={"row"} alignItems={"center"}>
                <Box
                  sx={{
                    fontWeight: 600,
                    letterSpacing: "0.32px",
                    padding: "1px 8px",
                    color: "#ffffff",
                    width: "fit-content",
                  }}
                >
                  <Stack
                    direction={"row"}
                    justifyContent={"center"}
                    gap={"5px"}
                    alignItems={"center"}
                    px={"5px"}
                  >
                    <Typography>
                      {formatDate(startDate, "D MMMM YYYY")} -{" "}
                    </Typography>
                    <Typography>
                      {formatDate(endDate, "D MMMM YYYY")}
                    </Typography>
                  </Stack>
                </Box>

                <IconButton
                  onClick={(event) => setAnchorEl(event.currentTarget)}
                >
                  <Calendar2 />
                </IconButton>
                <Box
                  sx={{
                    width: "1px",
                    height: "31px",
                    background: "#CACDD7",
                    margin: "0px 20px",
                  }}
                ></Box>

                <ContainedButton
                  disabled={!startDate || !endDate || !registerType}
                  label={"Apply Filter"}
                  sx={{
                    color: "#ffffff",
                    width: "fit-content",
                    boxShadow: "0",
                  }}
                  onClick={refetch}
                  loading={isLoading}
                />
                <Stack direction={"row"} gap={"20px"} ml={"10px"}>
                  <IconButton
                    onClick={(event) => setDownloadEl(event.currentTarget)}
                  >
                    <Download />
                  </IconButton>

                  <Popover
                    open={!!downloadEl}
                    anchorEl={downloadEl}
                    onClose={() => setDownloadEl(null)}
                    anchorOrigin={{
                      vertical: "bottom",
                      horizontal: "left",
                    }}
                  >
                    {csvLoader ? (
                      <Stack sx={{ p: 2 }}>
                        <LottieLoader />
                      </Stack>
                    ) : (
                      <IconButton onClick={downloadCSV}>
                        <Typography sx={{ p: 2 }}>Csv</Typography>
                      </IconButton>
                    )}
                    <Divider />
                    {excelLoader ? (
                      <Stack sx={{ p: 2 }}>
                        <LottieLoader />
                      </Stack>
                    ) : (
                      <IconButton onClick={downloadExcel}>
                        <Typography sx={{ p: 2 }}>Excel</Typography>
                      </IconButton>
                    )}
                  </Popover>
                </Stack>
              </Stack>
            </Stack>
            <Card
              sx={{
                px: "20px",
                height: `${
                  chartData?.xAxis?.length === 0 &&
                  chartData?.yAxis?.length === 0
                    ? "203px"
                    : "400px"
                }`,
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              {chartData?.xAxis?.length === 0 &&
              chartData?.yAxis?.length === 0 ? (
                <Typography variant="h6">No chart found</Typography>
              ) : (
                <ReadClusterLineChart
                  xAxisData={chartData.xAxis}
                  yAxisData={chartData?.yAxis}
                  legend={chartData?.legend || ""}
                />
              )}
            </Card>
          </Grid2>
          <Grid2 size={{ xs: 12, md: 12, lg: 5 }}>
            <Stack
              direction={"row"}
              justifyContent={"flex-end"}
              gap={"20px"}
              m={"20px"}
            >
              <ContainedButton
                label={"Upload Reads"}
                sx={{
                  color: "#ffffff",
                }}
                onClick={() => setCreateReadValueModal(true)}
              />
            </Stack>
            <Card
              sx={{
                px: "20px",
                pb: "20px",
                maxHeight: "640px",
                minHeight: "203px",
              }}
            >
              <CustomDataTable
                sx={{
                  maxHeight: "600px",
                  bgColor: "#1976d2 !important",
                }}
                columns={COLUMNS}
                rowsContent={rowsContent}
                totalCount={data?.length || 0}
                isLoading={isLoading}
                pagination={data?.length > 0}
                Actions={true}
                rowsPerPage={rowsPerPage}
                page={page}
                rowsPerPageOptions={[10, 50, 100, 250, 500]}
                onPageChange={(e, num) => setPage(num)}
                onRowsPerPageChange={(e) => {
                  setRowsPerPage(Number(e.target.value));
                  setPage(0); // Reset to first page when changing rows per page
                }}
              />
            </Card>
          </Grid2>
        </Grid2>
      </Stack>

      {meterId && updateReadValueModal && updateReadValueModal && (
        <UpdateReadValueModel
          onClose={() => setUpdateReadValueModal(null)}
          readValue={updateReadValueModal}
          meterId={meterId}
          onSuccess={() => {
            setUpdateReadValueModal(null);
            refetch();
          }}
        />
      )}

      <DateAndTimePopover
        anchorEl={anchorEl}
        setAnchorEl={setAnchorEl}
        startDate={startDate}
        endDate={endDate}
        handleDateChange={handleDateChange}
        timeRange={timeRange}
        setTimeRange={(timeRange) =>
          setTimeRange(
            Array.isArray(timeRange) ? timeRange : [timeRange, timeRange],
          )
        }
        handleDateSubmit={handleDateSubmit}
      />

      {createReadValueModal && meterId && (
        <CreateReadValueModel
          onClose={() => setCreateReadValueModal(false)}
          meterId={meterId}
          onSuccess={() => {
            setCreateReadValueModal(false);
            refetch();
          }}
          setToast={setToast}
        />
      )}
    </Box>
  );
};
